var React = require('react');

function Cycling (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",null,[React.createElement("circle",{"cx":"15","cy":"15","r":"14","key":0}),React.createElement("path",{"strokeLinecap":"square","d":"M1 15h12m4 0h12M15 29V17.002M15 13V1M5.1 24.9l8.4-8.4m3-3l8.4-8.4M24.9 24.9l-8.4-8.4m-2.992-2.992L5.1 5.1","key":1})])));
}

Cycling.defaultProps = {"width":"30","height":"30","viewBox":"0 0 30 30"};

module.exports = Cycling;

Cycling.default = Cycling;
